export const READ = 'READ';
export const ADD = 'ADD';
export const EDIT = 'EDIT';

export const DELETE = 'DELETE';
export const REJECT = 'REJECT';

export const MODES = [READ, EDIT] as const;
export const ACTION_NAMES = [ADD, EDIT, DELETE] as const;

export const SIXTY_FPS = 1000 / 60;

const stickyHeaderHeightDesktop = 167;
const stickyHeaderHeightMobile = 80;
const scrollOffset = 35;

export const CREATE_RESUME_OFFSET_DESKTOP =
  stickyHeaderHeightDesktop + scrollOffset;
export const CREATE_RESUME_OFFSET_MOBILE =
  stickyHeaderHeightMobile + scrollOffset;
